export function copyToClipboard(type: string, copyString: string): Promise<void> {
  const data = [
    new ClipboardItem({
      [type]: new Blob([copyString], { type }),
    }),
  ];

  return navigator.clipboard.write(data).catch((err) => {
    console.log(err);
  });
}

export function copyTextToClipboard(copyString: string): Promise<void> {
  return navigator.clipboard.writeText(copyString);
}

export async function readBlobFromClipboardAsText(type: string) {
  return (await readBlobFromClipboard(type)).text();
}

export async function readBlobFromClipboard(type: string) {
  const clipboardItems = await navigator.clipboard.read();
  return await clipboardItems[0].getType(type);
}

export async function readFileFromClipboard(type: string) {
  const blob = await readBlobFromClipboard(type);
  return new File([blob], `${new Date().toISOString()}.${type.split('/')[1]}`, {
    type: blob.type,
    lastModified: Date.now(),
  });
}

export async function readTextFromClipboard() {
  return await navigator.clipboard.readText();
}
